import { WorkspaceServiceImpl } from './impl';
import { selfOwnedWidgetRegistry } from './selfOwnedWidgetRegistry';
import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { IsomorphicBindings } from 'src/types/bindings';

export const localWorkspaceServiceModule = new TypedContainerModule<IsomorphicBindings>((bind) => {
    bind('WorkspaceService').to(WorkspaceServiceImpl).inSingletonScope();
    bind('WorkspaceServiceProvider')
        .toDynamicValue((context) => () => context.container.get('WorkspaceService'))
        .inSingletonScope();
    bind('SelfOwnedWidgetRegistry').toConstantValue(selfOwnedWidgetRegistry);
});
